var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',[_c('TTabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab},on:{"change-tab":_vm.updateActiveTab},scopedSlots:_vm._u([_vm._l((_vm.tabs),function(tab){return {key:tab.key,fn:function(){return [_c('UserPrice',{key:tab.key,attrs:{"price_type":tab.key}})]},proxy:true}})],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }